import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const DownloadVDRFiles = createAsyncThunk(
    'dataRoom/downloadFiles',
    async (
        {
            engagementId,
            answerFileIds,
        }: { engagementId: number; answerFileIds: number[] },
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/files/download`,
                {
                    answerFileIds,
                },
                {
                    responseType: 'blob',
                }
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not download files at the moment.',
                    'error'
                );
                throw new Error('Failed to download files');
            }

            return response.data;
        } catch (error) {
            createNotification(
                'An error occurred while downloading files.',
                'error'
            );
            throw error;
        }
    }
);

